import { ItemList } from 'orm'

class CityList extends ItemList {
    getEntityKey() {
        return "contact/city"
    }
}

export const contactCityList = new CityList("contact_city__default")
